import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Login, ReturnLogin } from '../interfaces/LoginInterface';
import { map, from, of, Observable, firstValueFrom, observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { LoadingService } from '../../services/loading.service';
import { SnackbarService } from '../../services/snackbar.service';
import { getMessaging, getToken } from 'firebase/messaging'
@Injectable({
  providedIn: 'root'
})
export class AuthServices {

  status: boolean = this.token
  private isLoggedSub = new BehaviorSubject<boolean>(this.status)
  private snack = inject(SnackbarService)
  isLoggedSub$ = this.isLoggedSub.asObservable()
  url = environment.API_URL
  // urlNotification = environment.API_NOTIFICATION

  constructor(private http: HttpClient, private router: Router, private loading: LoadingService) { }

  async login(value: any) {
    this.loading.showLoading()
    const obs$ = await this.http.post<ReturnLogin>(`${this.url}/login/`, value)
    firstValueFrom(obs$)
      .then((result) => {
        this.snack.openSnackBar(result.message)
        this.isLoggedSub.next(true)
        sessionStorage.setItem('user', JSON.stringify(result.user))
        localStorage.setItem('AccessToken', result.AccessToken)
        localStorage.setItem('RefreshToken', result.RefreshToken)
        localStorage.setItem('user', JSON.stringify(result.user))
        localStorage.setItem('permissions', JSON.stringify(result.user.permission_action))

        this.router.navigate(['sites'])
        this.loading.hideLoading()
        //this.requestPermission()
      }).catch((err) => {
        console.log(err, 'error')
        this.loading.hideLoading()

        if (err.status == 400) {
          this.snack.openSnackBar(err.error.message)
          return
        }
        if (err.status == 0) {
          this.snack.openSnackBar("Ocurrio un error, por favor comunicarse con el administrador")
          return
        }
        this.snack.openSnackBar(err.error?.message||"Ocurrio un error, por favor comunicarse con el administrador" )
        return
      });
  }

  setLoggin() {
    this.isLoggedSub.next(false)
  }

  async logout() {
    this.isLoggedSub.next(false)
    sessionStorage.clear()
    localStorage.clear()
    location.href = '/login'
  }

  get token(): boolean {
    const a = !!localStorage.getItem('AccessToken')
    // console.log(a);
    return a
  }
  // requestPermission() {
  //   const messaging = getMessaging();
  //   getToken(messaging, { vapidKey: environment.firebase.vpaidkey }).then(
  //     (currentToken: any) => {
  //       if (currentToken) {
  //         const user = JSON.parse(sessionStorage.getItem('user') || '{}');
  //         const body = {

  //           "browser_token_id": currentToken,
  //           "user": user.id,
  //           "department": user.management

  //         }
  //         let obs$ = this.http.post<any>(`${this.url}/api/gsoft/notifications/token/`, body)
  //         firstValueFrom(obs$)

  //       } else {
  //         console.log('error con el token');

  //       }
  //     }
  //   )
  // }


}
